"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _omit = _interopRequireDefault(require("transmute/omit"));

var _I18n = _interopRequireDefault(require("I18n"));

var propTypes = {
  autoFocus: _react.PropTypes.bool,
  propertyIndex: _react.PropTypes.number,
  value: _react.PropTypes.oneOfType([_react.PropTypes.string.isRequired, _react.PropTypes.number.isRequired])
};

var PropertyInputDuration =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputDuration, _React$Component);

  function PropertyInputDuration() {
    (0, _classCallCheck2.default)(this, PropertyInputDuration);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputDuration).apply(this, arguments));
  }

  (0, _createClass2.default)(PropertyInputDuration, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        this.focus();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.refs.input.focus();
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var value = this.props.value;

      if (value == null || isNaN(value) || value === '') {
        return value;
      }

      return _I18n.default.moment.duration(parseInt(value, 10)).humanize();
    }
  }, {
    key: "render",
    value: function render() {
      var transferableProps = (0, _omit.default)(['baseUrl', 'isInline', 'getProperty', 'objectType', 'onCancel', 'onInvalidProperty', 'propertyIndex', 'readOnlySourceData', 'resolver', 'showError', 'showPlaceholder', 'subject', 'subjectId', 'secondaryChanges', 'onSecondaryChange', 'onTracking', 'isRequired'], this.props);
      return _react.default.createElement(_UITextInput.default, (0, _extends2.default)({}, transferableProps, {
        "data-modalfocus": this.props.autoFocus,
        ref: "input",
        value: this.getValue(),
        autoComplete: "off",
        readOnly: true
      }));
    }
  }]);
  return PropertyInputDuration;
}(_react.default.Component);

exports.default = PropertyInputDuration;
PropertyInputDuration.propTypes = propTypes;
PropertyInputDuration.defaultProps = _UITextInput.default.defaultProps;
module.exports = exports.default;